import FormElementMixin from '../mixins/FormElementMixin.js';

Vue.asyncComponent('ak-input-text', {
	mixins: [FormElementMixin],
}, 'form/controls/ak-input-text.html');